import { Box, Button, List, ListItem, Typography } from "@mui/material";
import React, { useState } from "react";
import styles from "../../styles/components/videoReleaseAssetsModal.module.scss";
// import Image from "next/image";
import assest from "../../json/assest";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ModalWrapperSmall from "../../ui/ModalWrapper/ModalWrapperSmall";
import VideoReleaseRepresented from "../VideoReleaseRepresented/VideoReleaseRepresented";
import ModalWrapperVideoAssets from "../../ui/ModalWrapper/ModalWrapperVideoAssets";
import {
  getUtcDateTime,
  getUtcDateTimeTwo,
  getUtcDateTwo,
} from "../../lib/functions/utils.lib";
import { Stack } from "@mui/system";
import { useMutation } from "react-query";
import { releaseVideo } from "../../api/functions/video.api";

const formatDate = (inputDateString) => {
  const inputDate = new Date(inputDateString);

  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, "0");
  const day = String(inputDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

const VideoReleaseAssetsModal = ({
  openVideoReleaseAssests,
  handleCloseVideoReleaseAssests,
  handleCloseVideoRelease,
  data,
  release_status,
}) => {
  const [openVideoReleaseRepresented, setOpenVideoReleaseRepresented] =
    React.useState(false);
  const handleClickOpenVideoReleaseRepresented = () => {
    setOpenVideoReleaseRepresented(true);
  };
  const handleCloseVideoReleaseRepresented = () => {
    setOpenVideoReleaseRepresented(false);
  };

  const [release_note, setRelease_note] = useState("");
  const [release_company, setRelease_company] = useState("");
  const [release_contact_date, setRelease_contact_date] = useState("");

  console.warn("release_status", release_status, data);

  const [attachments, setAttachments] = useState([]);
  const handleFileChange = (event) => {
    console.warn("event", event);
    const file = event.target.files?.[0];
    if (file) {
      setAttachments((curr) => [...curr, file]);
    }
  };

  const removeFile = (file_index) => {
    setAttachments((curr) => curr.filter((_, index) => file_index !== index));
  };

  const { mutate } = useMutation(releaseVideo, {
    onSuccess: (data) => {
      handleCloseVideoReleaseAssests();
      handleCloseVideoRelease();
    },
  });

  const handleConfirm = () => {
    const formData = new FormData();
    formData.append("video_id", data.id);
    formData.append("release_status", release_status);
    formData.append("release_company", release_company);
    formData.append("release_contact_date", release_contact_date);
    formData.append("release_note", release_note);
    // formData.append("", );
    // formData.append("message", messageData.message);

    // Append each attachment to the FormData
    if (attachments.length > 0) {
      attachments.forEach((file, index) => {
        formData.append(`release_files[${index}]`, file);
      });
    }
    mutate(formData);
  };

  // console.warn("attachments", attachments);
  return (
    <>
      <ModalWrapperVideoAssets
        open={openVideoReleaseAssests}
        onClose={handleCloseVideoReleaseAssests}
        handleClose={handleCloseVideoReleaseAssests}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.videoReleaseAssetsWrapper}>
          <Box className={styles.videoReleaseAssetsHeader}>
            <Box className={styles.videoReleaseAssetsHeaderImg}>
              <img
                src={assest.videoReleaseAssetsImg}
                width={136}
                height={86}
                alt=""
              />
            </Box>
            <Box className={styles.videoReleaseAssetsHeaderTxt}>
              <h4>
                {data.title}
                <span>(VSID: {data.id})</span>
              </h4>
              <p>Submitted on: {getUtcDateTimeTwo(data.created_at)}</p>
              <p>
                Submitter name: <span>{data.user?.name}</span>
              </p>
            </Box>
          </Box>

          <Box className={styles.videoReleaseAssetsBody}>
            {release_status == 1 && (
              <Box className={styles.messageInput}>
                <label>
                  Please provide additional details regarding your reasons for
                  releasing this video.
                </label>
                <textarea
                  value={release_note}
                  onChange={(e) => setRelease_note(e.target.value)}
                ></textarea>
              </Box>
            )}

            {/* For copyright dispute */}
            {release_status == 2 && (
              <Box className={styles.copyRightInput}>
                <Box className={styles.messageInput}>
                  <label>Please enter the complainant’s name</label>
                  <input
                    type="text"
                    placeholder=""
                    value={release_company}
                    onChange={(e) => setRelease_company(e.target.value)}
                  />
                </Box>
                <Box className={styles.messageInput}>
                  <label>Contact Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      onChange={(e) =>
                        setRelease_contact_date(formatDate(e.$d))
                      }
                      label="Basic date picker"
                    />
                  </LocalizationProvider>
                </Box>

                <Box className={styles.messageInput}>
                  <label>Note</label>
                  <textarea
                    value={release_note}
                    onChange={(e) => setRelease_note(e.target.value)}
                  ></textarea>
                </Box>
              </Box>
            )}

            <Box className="attachFileinput attachFileinputMessage">
              <input
                type="file"
                id="upload"
                onChange={handleFileChange}
                hidden
              />
              <label htmlFor="upload">
                <img src={assest.attachIcon} width={13} height={15} alt="" />{" "}
                Attach a file
              </label>
            </Box>
            <Stack direction="row" className={styles.filesName}>
              <List className={styles.fileLists}>
                {attachments?.length
                  ? attachments.map((item, index) => {
                      return (
                        <ListItem key={index}>
                          <span className={styles.btnStyledFile}>
                            <img
                              src={assest.IconTrash}
                              width={16}
                              height={16}
                              alt="icon"
                            />
                            <Typography variant="overline">
                              {item?.name ? item.name : "N/A"}
                            </Typography>
                          </span>
                          <Button
                            className={styles.btnClose}
                            onClick={() => removeFile(index)}
                          >
                            <img
                              src={assest.IconcrossRound}
                              width={20}
                              height={20}
                              alt="icon"
                            />
                          </Button>
                        </ListItem>
                      );
                    })
                  : ""}
                {attachments?.length ? (
                  <ListItem>
                    <Box className={styles.addFiles}>
                      <input
                        type="file"
                        id="upload"
                        onChange={handleFileChange}
                        hidden
                      />
                      <label htmlFor="upload">
                        <img
                          src={assest.IconAddfile}
                          width={23.29}
                          height={23.29}
                          alt=""
                        />
                      </label>
                    </Box>
                  </ListItem>
                ) : (
                  ""
                )}
              </List>
            </Stack>
          </Box>

          <Box className={styles.videoReleaseAssetsFooter}>
            <Button onClick={handleCloseVideoReleaseAssests}>Cancel</Button>
            <Button className={styles.active} onClick={handleConfirm}>
              Save & Confirm
            </Button>
          </Box>

          {/* <ModalWrapperSmall
            open={openVideoReleaseRepresented}
            onClose={handleCloseVideoReleaseRepresented}
            handleClose={handleCloseVideoReleaseRepresented}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <VideoReleaseRepresented />
          </ModalWrapperSmall> */}
        </Box>
      </ModalWrapperVideoAssets>
    </>
  );
};

export default VideoReleaseAssetsModal;
